import { useCallback, useContext } from "react";
import { ErrorHandlerContext } from "../../contexts/ErrorHandlerContext";

import "./errorhandler.css";

// Icons for notifications
const ErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
);

const SuccessIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
        <polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
);

const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
);

/**
 * Parse message from error or success object
 * Supports both string messages and objects with msg property
 */
function parseMessage(notification) {
    if (typeof notification === "string") return notification;
    if (notification === undefined || notification === null) return "Нет сообщения";
    return notification.msg || "Неизвестное сообщение";
}

/**
 * Check if message is a success message
 * Success messages are objects with type: "success"
 */
function isSuccessMessage(notification) {
    if (typeof notification === "string") return false;
    if (notification === undefined || notification === null) return false;
    return notification.type === "success";
}

/**
 * Individual notification item component
 */
function NotificationItem({ notification }) {
    const { removeNotification } = useContext(ErrorHandlerContext);
    
    const isSuccess = isSuccessMessage(notification);
    const message = parseMessage(notification);
    
    const handleClose = useCallback(() => {
        removeNotification(notification.id);
    }, [removeNotification, notification.id]);

    return (
        <div className={`notification-item ${isSuccess ? 'notification-success' : 'notification-error'}`}>
            <div className="notification-icon">
                {isSuccess ? <SuccessIcon /> : <ErrorIcon />}
            </div>
            <p className="notification-text">{message}</p>
            <button 
                className="notification-close" 
                onClick={handleClose}
                aria-label="Закрыть уведомление"
            >
                <CloseIcon />
            </button>
        </div>
    );
}

/**
 * Main ErrorHandler component
 * Displays notifications at the bottom-left of the screen
 */
export default function ErrorHandler() {
    const { errorList } = useContext(ErrorHandlerContext);

    if (!errorList || errorList.length === 0) {
        return null;
    }

    return (
        <div className="notification-container" role="alert" aria-live="polite">
            {errorList.map((notification) => (
                <NotificationItem key={notification.id} notification={notification} />
            ))}
        </div>
    );
}
